import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select, MenuItem, OutlinedInput, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const OLDiscountSingleField = props => {
  const { options, label, i, name, handleChangeCallback, prevId, selectedPromotions,
    value, selectedPromotionsCount, discount, maxStandardPromotionsPerSeason,
    discountCodePromotions, metaDataPromotions } = props;
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (selectedPromotionsCount > i && discount[i + 1]) {
      return;
    }
    setOpen(true);
  };

  const handleChange = e => {
    handleChangeCallback(e.target.value, i);
  };

  const filteredOptions = () => {
    if (!options) {
      return [];
    }
    const maxPromotions = maxStandardPromotionsPerSeason;

    const currentId = selectedPromotions[i];
    const spf = [...selectedPromotions, ...discountCodePromotions]
      .filter(Boolean)
      .filter(id => id !== currentId);

    if (maxPromotions === 0) {
      return [];
    }

    if (maxPromotions && spf.length >= maxPromotions) {
      return [];
    }

    const discountCodePromotionsOptions = metaDataPromotions
      .filter(m => discountCodePromotions.includes(m.id))
      .map(m => ({
        ...m,
        promotions_excluded_from_connecting_with:
        m.promotions_excluded_from_connecting_with_ids
      }));
    const allPromotionObjects = [
      ...options,
      ...discountCodePromotionsOptions
    ];
    // brak wybranych promocji
    if (spf.length === 0) {
      return options.filter(op => !spf.includes(op.id));
    }

    // jedna promocja
    if (spf.length === 1) {
      const promotion = allPromotionObjects.find(op => op.id == spf[0]);

      if (!promotion) {
        return [];
      }

      const excluded = promotion.promotions_excluded_from_connecting_with.map(Number);

      return options.filter(op => excluded.includes(op.id));
    }

    // więcej promocji

    const promotions = allPromotionObjects.filter(op => spf.includes(op.id));

    // jeśli któraś promocja nie może się łączyć z innymi → nic nie pokazujemy
    if (promotions.some(p => !p.can_connect_with_other_promotions)) {
      return [];
    }

    const commonIds = promotions
      .map(p => p.promotions_excluded_from_connecting_with.map(Number))
      .reduce((a, b) => a.filter(id => b.includes(id)));

    return options.filter(opt => commonIds.includes(opt.id));

  };

  const description = () => {
    let s = '';
    if (value && !_.isEmpty(options)) {
      const fil = _.filter(options, o => o.id == value);
      if (fil.length > 0) {
        s = fil[0].description;
      }

      return s;
    }
  };

  return (
    !_.isEmpty(filteredOptions()) ? <FormControl sx={{ width: '100%' }}>
      <InputLabel htmlFor={`lab${i}`}>{label}</InputLabel>
      <Select
        disabled={(selectedPromotionsCount > i && discount[i + 1])}
        input={<OutlinedInput id={`lab${i}`} label={label} />}
        sx={{
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.light'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.main'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.dark'
          }
        }}
        value={value || ''}
        onChange={e => handleChange(e)}
        labelId={name}
        open = {open}
        onOpen = {handleOpen}
        onClose = {handleClose}
        IconComponent={_props => {
          const rotate = _props.className.toString().includes('iconOpen');

          return (
            <div>
              { rotate
                ? <div style={{ color: 'red', cursor: 'pointer', marginRight: 5, marginBottom: 5, fontSize: 20 }}>X</div>
                : <div><KeyboardArrowDownIcon
                  style={{ cursor: 'pointer' }}
                  onClick = {handleOpen}
                /></div> }
            </div>
          );
        }}

      >
        <MenuItem value=""><Typography color="green">{t('reset_discounts')}</Typography></MenuItem>
        { _.map(filteredOptions(), (item, key) => (
          <MenuItem style={{ whiteSpace: 'normal' }} key={key} value={item.id} id={item.name} data-description={item.description}>
            {item.name}
          </MenuItem>
        ))
        }
      </Select>
      <Typography color="green">{description()}</Typography>
    </FormControl> : null
  );
};
